import React, {Component} from 'react';
import withNofeshService  from '../../hoc/withNofeshService.hoc';
import compose from '../../utils/compose'
import SearchPanelCycleItem from './search_panel_cycle_item.component'
import { AppDataParam, EntitlmentStatusTypes} from '../../utils/constUtils'


class SearchPanelCycles extends Component {
    
    state = {
       vacationCyclesYears: [],
       cycleMessage:''
    }
    

    componentDidMount = () => {
              
        const { vacationCyclesYears } = this.props.personData;  
        this.setState({ vacationCyclesYears: vacationCyclesYears}); 
        
    }
  



    resetChecked = (cycle) => {
        let t = cycle;
        t.selected = false;
        return t;        
    }

    toggleYearCycle = (o) => {        
        let chld = o;
        chld.selected = true;
        this.setState(prevState => ({        
            vacationCyclesYears: prevState.vacationCyclesYears.map(
            obj => (
                obj.key === o.key ? 
                Object.assign(obj, chld) :  
                this.resetChecked(obj))
          )
        }));               
        
        console.log('toggleYearCycle' , o.key);


       const data = {                       
            vacationSelectedCycleYear: o.year,
            vacationSelectedCycleMonths: o.entitlementMonths
        };        
        this.props.setCurrentAppData(data, AppDataParam.reset_to_new_search_param_vacationCyclesYears);
    }



    render() {    
        
        let cycleMessage = '';
        const {vacationSelectedCycleYear} = this.props.currentSearchObj; 
        var selectedCycleArr = this.state.vacationCyclesYears.filter(cycle => {
            return cycle.year == vacationSelectedCycleYear
        });

        if(selectedCycleArr.length != 0)
        {
            let selectedCycle = selectedCycleArr[0];
            //console.log('SearchPanelCycles componentDidMount selectedCycle0', selectedCycle);

                    
            if (selectedCycle.EntitlmentStatusId == EntitlmentStatusTypes.EntitlementNotOrdered) {
                cycleMessage = EntitlmentStatusTypes.EntitlementNotOrderedMessage; 
            }
            
            if (selectedCycle.EntitlmentStatusId == EntitlmentStatusTypes.EntitlementOrderedNotRealized) {
                cycleMessage = EntitlmentStatusTypes.EntitlementOrderedNotRealizedMessage;
            }
        }

        
        //console.log('SearchPanelCycles componentDidMount selectedCycle.EntitlmentStatusId', selectedCycle.EntitlmentStatusId);
        


            

        const vacationCyclesYears = this.state.vacationCyclesYears.map((o,index) => {
            return (
                <SearchPanelCycleItem  
                    key={o.key} cycle={o}  
                    toggleYearCycle={this.toggleYearCycle} 
                />
            )
        });        

        return (


                    <React.Fragment>

                        <div className="cntered-flex directionRtl">
                            <div className="cntered-flex hp_search_width300 calendarinnerTitle">
                                {vacationCyclesYears}
                            </div>
                        </div>

                        <div className="hp_search_pad1_line"></div>
                        <div className="hp_search_pad1">
                            <div className="hp_search_title2">
                                <div className="paddingTop15">{cycleMessage}</div>
                            </div>
                        </div>
                    </React.Fragment>
           
        )
    }
}


  export default compose(
    withNofeshService()
  )(SearchPanelCycles);
  